exports = module.exports = require("../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".masthead-component.masthead-component.masthead-component{position:absolute;border-bottom:1px solid rgba(0,0,0,.2);top:0;left:0;width:100%;z-index:100;padding:0;background-color:#fff}.masthead-component.masthead-component.masthead-component.inverted{border-bottom:none;color:#f5f5f5;background-color:transparent}.masthead-component.masthead-component.masthead-component .logo{margin:1.414ex 0;max-height:3ex;min-width:3ex;width:auto}.masthead-component.masthead-component.masthead-component .mobile.only.column .logo{max-width:3ex}.masthead-component.masthead-component+*>*>:first-child:before{content:\"\";display:block;height:80px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/@ta-interaktiv/react-masthead/style/Masthead.css
// module id = 71
// module chunks = 0